"use client";

import { useMemo } from "react";
import DocumentLayout from "../(components)/DocumentLayout";

const Terms = ({ params }: any) => {
  const navigationItems = useMemo(
    () => [
      { id: "geltungsbereich", title: "1. Geltungsbereich, Allgemeines" },
      { id: "geltungsprioritaet", title: "2. Geltungspriorität" },
      { id: "angebot", title: "3. Angebot, Vertragsschluss" },
      {
        id: "bereitstellung",
        title: "4. Bereitstellung des OMTO-DKTB-Dienstes",
      },
      {
        id: "datenspeicherung",
        title: "5. Datenspeicherung, Datenverarbeitung",
      },
      { id: "support", title: "6. Technischer Support" },
      { id: "mobilgeraete", title: "7. Überlassung von Mobilgeräten" },
      { id: "pflichten", title: "8. Allgemeine Pflichten des Kunden" },
      { id: "vertragslaufzeit", title: "9. Vertragslaufzeit und Kündigung" },
      { id: "nutzungsgebuehr", title: "10. Nutzungsgebühr, Fälligkeit" },
      { id: "gewaehrleistung", title: "11. Gewährleistung" },
      { id: "haftung", title: "12. Haftung" },
      { id: "vertraulichkeit", title: "13. Vertraulichkeit" },
      { id: "abtretung", title: "14. Abtretung, Aufrechnung" },
      { id: "schlussbestimmungen", title: "15. Schlussbestimmungen" },
      { id: "sla", title: "16. Einbeziehung der Service-Level-Vereinbarung" },
      { id: "erklaerung", title: "Erklärung des Kunden" },
      { id: "sla-anhang", title: "Anhang SLA" },
    ],
    [],
  );

  return (
    <DocumentLayout
      params={params}
      titleKey="terms"
      navigationItems={navigationItems}
      basePath="/terms"
    >
      <div
        id="geltungsbereich"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            1. Geltungsbereich, Allgemeines
          </h2>
          <p>
            1.1. Die Bereitstellung, Nutzungsgewährung, Hardwareüberlassung
            sowie die sonstigen Leistungen der OMTO GmbH, Kitzingstraße 15-19,
            12277 Berlin (im Folgenden OMTO genannt) in Bezug auf den Dienst
            „OMTO – Digitale Krankentransport-Bestellung“ (OMTO-DKTB-Dienst)
            erfolgen ausschließlich auf der Grundlage dieser Allgemeinen
            Geschäftsbedingungen (AGB-DKTB).
          </p>
          <p>
            1.2. Diese AGB gelten ausschließlich. Abweichende, entgegenstehende
            oder ergänzende Geschäftsbedingungen des Kunden werden nur dann und
            insoweit Vertragsbestandteil, als OMTO ihrer Geltung ausdrücklich
            zugestimmt hat. Dieses Zustimmungserfordernis gilt in jedem Fall,
            beispielsweise auch dann, wenn OMTO in Kenntnis der
            Geschäftsbedingungen des Kunden die Leistung an ihn vorbehaltlos
            ausführt.
          </p>
          <p>
            1.3. Sofern nichts anderes vereinbart wird, gelten diese AGB-DKTB
            auch für etwaig in der Zukunft bereitgestellte Leistungen durch OMTO
            an den Kunden im Geltungsbereich dieser AGB-DKTB, ohne dass OMTO in
            jedem Einzelfall wieder auf diese AGB hinweisen müsste.
          </p>
          <p>
            1.4. Die Verwendung der Bezeichnung „Kunde“ in der männlichen Form
            erfolgt ausschließlich zum Zwecke der sprachlichen Vereinfachung.
            Mit diesem Begriff sind ausdrücklich auch weibliche und diverse
            Vertragspartner sowie juristische Personen gemeint.
          </p>
        </div>
      </div>

      <div
        id="geltungsprioritaet"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            2. Geltungspriorität
          </h2>
          <p>
            2.1. Im Einzelfall getroffene, individuelle Vereinbarungen mit dem
            Kunden (einschließlich Nebenabreden, Ergänzungen und Änderungen)
            haben in jedem Fall Vorrang vor diesen AGB. Für den Inhalt
            derartiger Vereinbarungen ist, vorbehaltlich des Gegenbeweises, ein
            schriftlicher Vertrag bzw. die schriftliche Bestätigung von OMTO
            maßgebend.
          </p>
          <p>
            2.2. Bei Auslegungsproblemen oder Widersprüchen zwischen etwaigen
            Individualvereinbarungen, Auftragsverarbeitungsverträgen (AVV),
            etwaigen gesonderten Service-Level-Vereinbarungen und diesen AGB
            wird folgender Geltungsvorrang festgelegt:
          </p>
          <ul className="list-['-__'] pl-7 space-y-1">
            <li>an erster Stelle stehen Individualvereinbarungen</li>
            <li>
              an zweiter Stelle stehen Auftragsverarbeitungsverträge (AVV)
            </li>
            <li>
              an dritter Stelle stehen sonstige beidseitig signierte Verträge
            </li>
            <li>
              an vierter Stelle stehen gesonderte Service-Level-Vereinbarungen
            </li>
            <li>
              an fünfter Stelle stehen diese AGB-DKTB einschließlich des Anhangs
              SLA
            </li>
          </ul>
          <p>
            2.3. Hinweise auf die Geltung gesetzlicher Vorschriften haben nur
            klarstellende Bedeutung. Auch ohne eine derartige Klarstellung
            gelten die gesetzlichen Vorschriften, soweit sie in diesen AGB nicht
            unmittelbar abgeändert oder ausdrücklich ausgeschlossen werden.
          </p>
        </div>
      </div>

      <div id="angebot" className="flex flex-col items-start lg:flex-row gap-8">
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            3. Angebot, Vertragsschluss
          </h2>
          <p>
            3.1. Die Angebote von OMTO sind freibleibend und unverbindlich,
            sofern sie nicht ausdrücklich als verbindlich gekennzeichnet sind
            oder eine bestimmte Annahmefrist enthalten. Die Darstellung von
            Produkten / Leistungen in allgemeinen Informationsmedien (z.B. auf
            der Webseite in allgemeinen Präsentationen) von OMTO stellt kein
            rechtlich bindendes Angebot, sondern nur eine Aufforderung zur
            Bestellung („invitatio ad offerendum“) dar.
          </p>
          <p>
            3.2. OMTO stellt dem Kunden ein Bestellformular zur Verfügung, mit
            dem der Kunde das/die angebotene/n Produkt/e bei OMTO bestellen
            kann. Bestellungen durch den Kunden gelten für diesen als
            unwiderruflich abgegeben. Der Kunde ist an seine Bestellung für die
            Dauer von sieben Kalendertagen gebunden.
          </p>
          <p>
            3.3. Der Vertrag zwischen dem Kunden und OMTO kommt zustande sobald
            OMTO die jeweilige Bestellung durch eine gesonderte E-Mail annimmt
            (Annahmebestätigung) oder das/die zu übelassenende/n
            OMTO-Mobilgerät/e (Ziffer 7) in den Versand gibt bzw. dem Kunden per
            E-Mail eine Versandbestätigung zusendet.
          </p>
          <p>
            3.4. Soweit zum Abschluss eines Vertrags vom Kunden zu signierende
            Vertragsdokumente vorgesehen sind, die von OMTO z.B. per DocuSign
            oder ähnlichen Signierungsdiensten bereitgestellt werden, kommt der
            entsprechende Vertrag mit der Signatur zustande.
          </p>
          <p>
            3.5. Die Angaben von OMTO zum Gegenstand des OMTO-DKTB-Dienstes
            (z.B. Funktionen und technische Daten) sowie die Darstellungen
            desselben (z.B. Abbildungen, Videos) sind nur annähernd maßgeblich,
            soweit nicht die Verwendbarkeit zum vertraglich vorgesehenen Zweck
            eine genaue Übereinstimmung voraussetzt. Sie sind keine garantierten
            Beschaffenheitsmerkmale, sondern Beschreibungen oder Kennzeichnungen
            der betreffenden Leistung. Branchenübliche Abweichungen und
            Abweichungen, die aufgrund rechtlicher Vorschriften erfolgen oder
            technische Verbesserungen darstellen, sowie die Ersetzung von
            Funktionen durch gleichwertige Funktionen sind zulässig, soweit sie
            die Verwendbarkeit zum vertraglich vorgesehenen Zweck nicht
            beeinträchtigen, den OMTO-DKTB-Dienst bzw. den Leistungsgegenstand
            nicht erheblich ändern und die Änderungen für den Kunden nicht
            unzumutbar sind.
          </p>
        </div>
      </div>

      <div
        id="bereitstellung"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            4. Bereitstellung des OMTO-DKTB-Dienstes
          </h2>
          <p>
            4.1. Mit dem OMTO-DKTB-Dienst bietet OMTO eine digitale
            Dienstleistung mit den Features:
          </p>
          <ul className="list-disc pl-7 space-y-1">
            <li>
              digitale Bestellung von Krankenbeförderungen durch Krankenhäuser,
              Pflege- und Senioreneinrichtungen o.ä. gegenüber angeschlossenen
              Transportunternehmen
            </li>
            <li>
              digitale Erfassung der Felder des Formulars „Verordnung einer
              Krankenbeförderung Muster 4“ über die Kamera von OMTO-Mobilgeräten
              (Ziffer 7) und OCR-Auswertung der Formulardaten zur Erleichterung
              der Digitalisierung dieser Daten
            </li>
            <li>
              automatisierte Prüfung der digitalisierten Formulardaten auf
              Vollständigkeit sowie Übertragung der Daten an das
              Transportunternehmen und Softwaredienstleister
            </li>
            <li>
              Dashboard für die digitale Verwaltung von Krankentransportfahrten
              (nur für Transportunternehmen) und Speicherung der
              Krankentransport-Daten
            </li>
          </ul>
          <p>
            Die konkrete Funktionalität sowie die Einsatzbedingungen des
            OMTO-DKTB-Dienstes ergeben sich aus dem Informationsmaterial, das
            dem Kunden von OMTO zur Verfügung gestellt wird.
          </p>
          <p>
            4.2. Gegenstand des Vertrags zwischen OMTO und dem Kunden ist die
            entgeltliche, zeitlich auf die Vertragsdauer begrenzte Gewährung der
            Nutzung des OMTO-DKTB-Dienstes im Wege des „Software as a Service“
            über Fernkommunikationsnetze (SaaS), die Speicherung der zu diesem
            Dienst erfassten Daten und die Nutzung der OMTOMobilgeräte (Ziffer
            7) im jeweils vereinbarten Umfang. OMTO gewährt dem Kunden die
            Nutzung des OMTO-DKTB-Dienstes in folgender Weise:
          </p>
          <ul className="list-alpha pl-7 space-y-1">
            <li>
              Bereitstellung der OMTO-App (Android) auf den OMTO-Mobilgeräten,
              über die die Formulardaten der „Verordnung einer
              Krankenbeförderung Muster 4“ erfasst und die
              Krankentransport-Bestellung erstellt werden können; die Nutzung
              der OMTOApp ist ausschließlich auf den überlassenen
              OMTO-Mobilgeräten zulässig;
            </li>
            <li>
              Bereitstellung einer Webanwendung, auf die über jeden gängigen
              Internetbrowser (insbesondere Google Chrome, Microsoft Edge,
              Firefox, Apple Safari) zugegriffen werden kann, für den Zugang zum
              OMTO-DKTB-Dashboard; das OMTO-DKTBDashboard steht nur
              Krankentransportunternehmen zur Verfügung.
            </li>
          </ul>
          <p>
            4.3. OMTO wird ausdrücklich nicht Vertragspartei des
            Krankenbeförderungsvertrags und schuldet weder eine
            Krankenbeförderung noch die Vermittlung einer solchen.
          </p>
          <p>
            4.4. Bedingung für die Bereitstellung des OMTO-DKTB-Dienstes an den
            Kunden ist der Abschluss eines gesonderten
            Auftragsverarbeitungsvertrags im Sinne des Art. 28 Abs. 3 DSGVO. Die
            Freischaltung des OMTO-DKTB-Dienstes für den Kunden erfolgt
            innerhalb von drei Werktagen nach Vertragsschluss. Stellt sich
            heraus, dass der zwischen den Parteien geschlossene
            Auftragsverarbeitungsvertrag den zwingenden datenschutzrechtlichen
            Anforderungen (insbesondere den Anforderungen der DSGVO) nicht
            genügt, ist jede Partei der jeweils anderen gegenüber verpflichtet,
            unverzüglich an einer Änderung des Auftragsverarbeitungsvertrags
            mitzuwirken, welche die datenschutzrechtlichen Mängel des
            ursprünglichen Auftragsverarbeitungsvertrags beseitigt und dem von
            den Parteien im ursprünglichen Auftragsverarbeitungsvertrag
            ausgewiesenen wirtschaftlichen Willen möglichst nahe kommt.
          </p>
          <p>
            4.5. Die Nutzung des OMTO-DKTB-Dienstes ist nur durch Personen
            möglich, die sich als Nutzer unter Eingabe des individuellen
            Nutzernamens und des Passworts (Zugangsdaten) registrieren und für
            die ein Nutzerkonto eröffnet ist. Die maximale Anzahl an berechtigen
            Nutzern (Nutzer-Lizenzen) ergibt sich aus der jeweiligen
            Vereinbarung; soweit nicht anderes vereinbart wird, sind zwei
            Nutzerlizenzen pro überlassenem OMTO-Mobilgerät inbegriffen.
          </p>
          <p>
            4.6. Der Kunde darf den OMTO-DKTB-Dienst nur im Rahmen seines
            Unternehmens bzw. seiner Organisation nutzen. Dem Kunden ist eine
            andere als die vertraglich bestimmte Nutzung des Dienstes nicht
            gestattet, insbesondere ist eine private Nutzung untersagt.
          </p>
          <p>
            4.7. OMTO kann den Dienst bzw. die Software des Dienstes jederzeit
            aktualisieren sowie weiterentwickeln und insbesondere aufgrund einer
            geänderten Rechtslage, technischer Entwicklungen oder zur
            Verbesserung der IT-Sicherheit anpassen. OMTO wird dabei die
            berechtigten Interessen des Kunden angemessen berücksichtigen und
            den Kunden rechtzeitig über Änderungen informieren. Im Falle einer
            wesentlichen Beeinträchtigung der berechtigten Interessen des
            Kunden, steht diesem ein Sonderkündigungsrecht zu.
          </p>
          <p>
            4.8. Eine Anpassung auf die individuellen Bedürfnisse oder die
            IT-Umgebung des Kunden schuldet OMTO nicht, es sei denn die Parteien
            haben abweichendes vereinbart.
          </p>
        </div>
      </div>

      <div
        id="datenspeicherung"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            5. Datenspeicherung, Datenverarbeitung
          </h2>
          <p>
            5.1. Die Speicherung der Daten, die im Zusammenhang mit der
            Krankenbeförderung anfallen (Krankentransport-Daten), erfolgt auf
            den von OMTO genutzten Servern, wobei OMTO hierzu die Dienste eines
            externen Rechenzentrums in Anspruch nimmt. Die von OMTO genutzten
            Server befinden sich ausschließlich in Deutschland; der Ort der
            Datenspeicherung und Datenverarbeitung des OMTO-DKTB-Dienstes ist
            Deutschland.
          </p>
          <p>
            5.2. OMTO sorgt für angemessene Maßnahmen zum Schutz der Daten und
            die Erfüllung der datenschutzrechtlichen Anforderungen des
            OMTO-DKTB-Dienstes. Die Einzelheiten sind im
            Auftragsverarbeitungsvertrag geregelt.
          </p>
          <p>
            5.3. Der Kunde bleibt stets Inhaber (Verantwortlicher im Sinne des
            Art. 4 Nr. 7 DSGVO oder Ober-Auftragsverarbeiter im Sinne des Art. 4
            Nr. 8 DSGVO, soweit er die Daten im Rahmen eines
            Auftragsverarbeitungsverhältnisses zu Dritten hält) der auf den von
            OMTO genutzten Servern gespeicherten Krankentransport-Daten und kann
            diese jederzeit herausverlangen. OMTO stehen hinsichtlich der
            Krankentransport-Daten weder ein Zurückbehaltungsrecht noch das
            gesetzliche Vermieterpfandrecht (§ 562 BGB) zu.
          </p>
          <p>
            5.4. Speicherplatz für andere Daten als die Krankentransport-Daten
            stellt OMTO nicht zur Verfügung. Der Kunde ist auch nicht
            berechtigt, den Speicherplatz einem Dritten teilweise oder
            vollständig, entgeltlich oder unentgeltlich zur Nutzung zu
            überlassen.
          </p>
        </div>
      </div>

      <div id="support" className="flex flex-col items-start lg:flex-row gap-8">
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            6. Technischer Support
          </h2>
          <p>
            6.1. OMTO bietet einen 24/7 technischen Support. Support-Anfragen
            des Kunden können jederzeit entweder telefonisch über die
            Support-Hotline oder per E-Mail über die Adresse „hilfe@omto.de“
            gestellt werden.
          </p>
          <p>
            6.2. Der technische Support ist nur für Anfragen des Kunden bzw.
            dessen Mitarbeitern in Bezug auf die Nutzung des OMTO-DKTB-Dienstes,
            insbesondere dessen Bedienung, Funktionen und Störungsfälle
            eingerichtet. Für sonstige Anfragen ist der technische Support nicht
            zuständig.
          </p>
        </div>
      </div>

      <div
        id="mobilgeraete"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            7. Überlassung von Mobilgeräten
          </h2>
          <p>
            7.1. OMTO überlässt dem Kunden entgeltlich in vertraglich
            vereinbarter Anzahl Smartphones des Typs Samsung Galaxy A 13 oder
            ähnlich (im Folgenden kurz „OMTO-Mobilgeräte“), die wie folgt
            ausgestattet sind:
          </p>
          <ul className="list-disc pl-7 space-y-1">
            <li>OMTO-App (Ziffer 4.2 a)</li>
            <li>Kamerafunktion</li>
            <li>Telefonfunktion</li>
          </ul>
          <p>
            7.2. Die Überlassung der OMTO-Geräte erfolgt als „Device as a
            Service“, das Mobile-DeviceManagement (MDM) wird in Deutschland
            ausgeführt. Die OMTO-Mobilgeräte befinden sich im sog.
            „Kiosk-Modus“, d.h. durch den Kunden selbst können keine anderen als
            die in Ziffer 7.1 aufgeführten Funktionen genutzt und keine anderen
            als die dort genannten Apps installiert werden. Auf Wunsch des
            Kunden können jedoch bei Bedarf weitere Funktionen oder gängige Apps
            (z.B. Google Maps) auf den Geräten durch OMTO gegen Mehrpreis
            freigeschaltet werden; ein Anspruch des Kunden auf Freischaltung
            weiterer Funktionen oder Apps besteht jedoch nicht.
          </p>
          <p>
            7.3. Die OMTO-Mobilgeräte sind mit einer eigenen Daten-SIM
            ausgestatten, das Entgelt für die Datenübertragung über das
            Mobilfunknetz (z.B. Telefonica/O2) ist im Mietpreis der
            OMTO-Mobilgeräte (Ziffer 10 b) beinhaltet und wird von OMTO
            getragen.
          </p>
          <p>
            7.4. Der Kunde darf die OMTO-Mobilgeräte nur für die Nutzung der
            OMTO-App, etwaig von OMTO auf dem jeweiligen Gerät freigeschalteter
            weiterer Apps sowie für Telefonate im Zusammenhang mit
            Krankentransporten verwenden. Jegliche anderen Verwendungen sind
            strikt untersagt, insbesondere untersagt ist jede Privatnutzung.
          </p>
          <p>
            7.5. Der Kunde ist verpflichtet, die Geräte pfleglich zu behandeln
            und sie jederzeit in geeigneter Weise vor Beschädigung, Verlust oder
            Diebstahl zu schützen und OMTO im Falle von Beschädigung, Verlust
            oder Diebstahl unverzüglich hiervon zu unterrichten. Der Kunde
            haftet OMTO für den Verlust der Geräte sowie für Schäden an diesen,
            die durch unsachgemäße Behandlung oder mutwillige Beschädigung der
            Mietgegenstände entstehen, es sei denn, den Kunden trifft hieran
            kein Verschulden.
          </p>
          <p>
            7.6. Ist der Kunde ein Transportunternehmen, darf er die Geräte den
            ihn beauftragenden Krankenhäusern, Pflege- oder
            Senioreneinrichtungen oder ähnlichen – üblicherweise
            Krankenbeförderungen beauftragenden – Organisationen zu den in
            Ziffer 7.4 Satz 1 genannten Zwecken weiterüberlassen. Im Falle der
            Weiterüberlassung ist der Kunde für die vertragsgemäße Verwendung
            der OMTO-Mobilgeräte durch die Dritten gegenüber OMTO haftbar.
          </p>
        </div>
      </div>

      <div
        id="pflichten"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            8. Allgemeine Pflichten des Kunden
          </h2>
          <p>
            8.1. Der Kunde hat die Zugangsdaten (Ziffer 4.5) dem Stand der
            Technik entsprechend vor Zugriffen Dritter zu schützen und zu
            verwahren. Der Kunde wird dafür sorgen, dass eine Nutzung des
            OMTO-DKTB-Dienstes nur im vertraglich vereinbarten Umfang erfolgt.
            Erhält der Kunde Kenntnis über einen unberechtigten Zugriff auf den
            OMTO-DKTBDienst, hat er OMTO hierüber unverzüglich zu
            benachrichtigen.
          </p>
          <p>
            8.2. Der Kunde darf über den OMTO-DKTB-Dienst keine Daten
            verarbeiten, deren Verarbeitung oder Nutzung gegen geltendes Recht –
            insbesondere gegen Datenschutzrecht – und/oder gegen behördliche
            Anordnungen verstößt und/oder Rechte Dritter verletzt. OMTO ist zur
            sofortigen Sperre der weiteren Datenerfassung und/oder -
            übermittlung über das Nutzerkonto des Kunden berechtigt, wenn der
            begründete Verdacht eines solchen Verstoßes bzw. einer Verletzung
            besteht. Ein begründeter Verdacht für eine Rechtswidrigkeit und/oder
            eine Rechtsverletzung liegt insbesondere dann vor, wenn Gerichte
            oder Behörden OMTO davon in Kenntnis setzen. OMTO hat den Kunden von
            der Sperre und dem Grund hierfür unverzüglich zu informieren. Die
            Sperre ist aufzuheben, sobald der Verdacht entkräftet ist.
          </p>
          <p>
            8.3. Ist der Kunde ein Transportunternehmen und wird er nicht von
            der zu befördernden Person, sondern von einem Krankenhaus, einer
            Pflege- oder Senioreneinrichtungen o.ä. beauftragt, hat der Kunde
            sicherzustellen, dass mit seinem jeweiligen Auftraggeber ein den
            Anforderungen der DSGVO entsprechender Auftragsverarbeitungsvertrag
            über die personenbezogenen Krankentransport-Daten vorhanden ist.
            OMTO stellt dem Kunden (als Service) ein Muster bzw. Template für
            eine speziell auf den OMTO-DKTB-Dienst bezogene Ergänzung des
            Auftragsverarbeitungsvertrags zwischen dem Kunden und seinem
            jeweiligen Auftraggeber zur Verfügung, die der Kunde gegenüber
            seinem Auftraggeber benutzen kann, aber nicht muss. Der Kunde ist
            jedoch in jedem Fall für die Vereinbarung wirksamer
            Auftragsverarbeitung-Regelungen auch bezogen auf den
            OMTO-DKTB-Dienst mit seinem jeweiligen Auftraggeber verantwortlich.
          </p>
          <p>
            8.4. Ungeachtet des Umstandes, dass OMTO nicht Vertragspartei des
            Krankenbeförderungsvertrags zwischen dem Transportunternehmen und
            dessen Auftraggeber wird, liegt es im Interesse von OMTO, dass das
            allgemeine Image des OMTO-DKTB-Dienstes nicht dadurch beeinträchtigt
            wird, dass die den Dienst nutzenden Transportunternehmen ihre
            Transportleistungen in erheblichen Umfang mangelhaft erbringen und
            dadurch als unseriös erscheinen. Daher wird sich der Kunde – wenn er
            ein Transportunternehmen ist – soweit zumutbar bemühen, seine
            Leistungen gegenüber seinem Beförderungsauftraggeber stets
            ordnungsgemäß zu erbringen.
          </p>
        </div>
      </div>

      <div
        id="vertragslaufzeit"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            9. Vertragslaufzeit und Kündigung
          </h2>
          <p>
            9.1. Der Vertrag über die Nutzung des OMTO-DKTB-Dienstes und die
            Überlassung des OMTO-Mobilgeräts (Ziffer 7) wird anfänglich für eine
            bestimmte Dauer (Mindestlaufzeit) geschlossen. Die anfängliche
            Mindestlaufzeit richtet sich nach Angabe in der jeweiligen
            Bestellung. Soweit nicht anders angegeben, gilt eine anfängliche
            Mindestlaufzeit von sechs (6) Monaten.
          </p>
          <p>
            9.2. Der Vertrag wird nach der anfänglichen Mindestlaufzeit auf
            unbestimmte Zeit fortgesetzt, wenn das Vertragsverhältnis nicht von
            einer Partei mit einer Frist von mindestens einem (1) Monat zum Ende
            der Mindestlaufzeit gekündigt wird. Erfolgt die Vertragsfortsetzung
            auf unbestimmte Zeit, ist der Vertrag von beiden Parteien mit einer
            Frist von einem (1) Monat zum Ende eines jeden Kalendermonats
            kündbar.
          </p>
          <p>
            9.3. Soweit mehr als ein OMTO-Mobilgerät überlassen wird, kann die
            Vereinbarung über die Überlassung der weiteren OMTO-Mobilgeräte –
            jeweils auch einzeln – (unabhängig von der allgemeinen
            Kündigungsfrist gemäß Ziffern 9.1 und 9.2) mit einer Frist von einem
            Monat (1) zum Ende eines jeden Kalendermonats gekündigt werden. Die
            Überlassung endet in jedem Fall automatisch mit Beendigung des
            Vertrags gemäß Ziffer 9.1 bzw. 9.2.
          </p>
          <p>
            9.4. Das gesetzliche Recht jeder Partei zur außerordentlichen
            Kündigung aus wichtigem Grund bleibt in allen Fällen unberührt. Ein
            außerordentliches Kündigungsrecht für OMTO besteht insbesondere in
            folgenden Fällen:
          </p>
          <ul className="list-alpha pl-7 space-y-1">
            <li>
              Der Kunde befindet sich mit mehr als zwei Monatsgebühren (Ziffer
              10.2) in Verzug.
            </li>
            <li>
              Der Kunde verstößt gegen seine Pflichten aus Ziffer 8.1, 8.2 oder
              8.3 dieser AGB.
            </li>
            <li>
              OMTO werden Umstände bekannt, die die Annahme begründen, dass die
              weitere Gewährung der Nutzung des OMTO-DKTB-Dienstes an den Kunden
              zu einer Beeinträchtigung des allgemeinen Images des Dienstes
              führen könnte. Diese Annahme soll insbesondere in einem Verstoß
              des Kunden gegen Ziffer 8.4 Satz 2 begründet sein.
            </li>
          </ul>
          <p>9.5. Jede Kündigung muss in Textform erfolgen.</p>
        </div>
      </div>

      <div
        id="nutzungsgebuehr"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            10. Nutzungsgebühr, Fälligkeit
          </h2>
          <p>
            10.1. Das Entgelt für die Nutzung des OMTO-DKTB-Dienstes und
            Überlassung von OMTOMobilgeräten (Nutzungsgebühr) richtet sich nach
            der vertraglichen Bestimmung oder – sofern keine solche
            Preisbestimmung zustande kommen sollte – nach der im Zeitpunkt des
            Vertragsschlusses (Ziffer 3.3) gültigen allgemeinen Preisliste von
            OMTO und setzt sich aus folgenden Bestandteilen zusammen:
          </p>
          <ul className="list-alpha pl-7 space-y-1">
            <li>
              Dienstnutzungsgebühr für die Nutzung des OMTO-DKTB-Dienstes an
              sich
            </li>
            <li>
              Geräteüberlassungsgebühr für die Überlassung der OMTO-Mobilgeräte
              (Ziffer 7)
            </li>
          </ul>
          <p>
            10.2. Die Nutzungsgebühr ist monatlich im Voraus, am dritten Werktag
            des Monats für den jeweiligen Kalendermonat zur Zahlung fällig
            (Monatsgebühr). Beginnt oder endet der Vertrag untermonatlich, wird
            die Monatsgebühr entsprechend anteilig berechnet.
          </p>
          <p>
            10.3. OMTO stellt dem Kunden monatlich eine Rechnung über die
            Monatsgebühr aus. Der Kunde erhält die Rechnung in elektronischer
            Form per E-Mail.
          </p>
          <p>
            10.4. Alle von OMTO angegebenen Preise verstehen sich als
            Nettopreise und werden zuzüglich der gesetzlichen Umsatzsteuer in
            Rechnung gestellt.
          </p>
        </div>
      </div>

      <div
        id="gewaehrleistung"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            11. Gewährleistung
          </h2>
          <p>
            11.1. Für die Rechte bei Sach- und Rechtsmängeln gelten die
            gesetzlichen Vorschriften, soweit nachfolgend nichts anderes
            bestimmt ist.
          </p>
          <p>
            11.2. OMTO leistet Gewähr für die Aufrechterhaltung der vertraglich
            vereinbarten Beschaffenheit bzw. Verfügbarkeit des
            OMTO-DKTB-Dienstes während der Vertragslaufzeit sowie dafür, dass
            einer vertragsgemäßen Nutzung des OMTO-DKTBDienstes keine Rechte
            Dritter entgegenstehen. Als Vereinbarung über die Beschaffenheit des
            OMTO-DKTB-Dienstes gelten erstrangig die Angaben im
            zugrundeliegenden Angebot oder – im Falle der Ziffer 3.3. – der
            Auftragsbestätigung sowie zweitrangig die sonstigen
            Programmbeschreibungen, die von OMTO (insbesondere auf deren
            Webseite) zum Zeitpunkt der Bestellung des Kunden öffentlich bekannt
            gemacht wurden.
          </p>
          <p>
            11.3. Die vertraglich vereinbarte Verfügbarkeit des
            OMTO-DKTB-Dienstes bestimmt sich nach den Regelungen zur
            Verfügbarkeit in der Service-Level-Vereinbarung (SLA), die als
            <strong>Anhang SLA</strong> zu diesen AGB beigefügt ist.
          </p>
          <p>
            11.4. Die Reaktionszeit zur Beseitigung von Mängeln des
            OMTO-DKTB-Dienstes bestimmt sich nach Maßgabe der
            Service-Level-Vereinbarung (Anhang SLA).
          </p>
          <p>
            11.5. Ansprüche des Kunden auf Schadensersatz bzw. Ersatz
            vergeblicher Aufwendungen bestehen auch bei Mängeln nur nach Maßgabe
            von Ziffer 12.
          </p>
        </div>
      </div>

      <div id="haftung" className="flex flex-col items-start lg:flex-row gap-8">
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            12. Haftung
          </h2>
          <p>
            12.1. Soweit sich aus diesen AGB einschließlich der nachfolgenden
            Bestimmungen nichts anderes ergibt, haftet OMTO bei einer Verletzung
            von vertraglichen und außervertraglichen Pflichten nach den
            gesetzlichen Vorschriften.
          </p>
          <p>12.2. OMTO haftet unbeschränkt:</p>
          <ul className="list-alpha pl-7 space-y-1">
            <li>bei Vorsatz oder grober Fahrlässigkeit</li>
            <li>
              für Schäden aus der Verletzung von Leben, Leib oder Gesundheit
            </li>
            <li>nach den Vorschriften des Produkthaftungsgesetzes sowie</li>
            <li>im Umfang einer von OMTO übernommenen Garantie</li>
          </ul>
          <p>
            OMTO haftet in den vorstehend zu lit. b) bis d) genannten Fällen
            ausdrücklich auch bei leichter Fahrlässigkeit unbeschränkt. Die
            nachfolgenden Haftungsbegrenzungen gemäß Ziffern 12.3. bis 12.5.
            gelten für diese Fälle nicht.
          </p>
          <p>
            12.3. OMTO haftet – außerhalb des Anwendungsbereichs der Ziffer
            12.2. – im Falle einfacher (leichter) Fahrlässigkeit nur bei
            Verletzung einer Vertragspflicht, deren Einhaltung wesentlich für
            die Erreichung des Vertragszwecks ist und auf deren Einhaltung der
            Kunde regelmäßig vertrauen darf (Kardinalpflicht). Kardinalpflichten
            sind insbesondere die Verpflichtung zur Bereitstellung des
            OMTO-DKTB-Dienstes, dessen Freiheit von Rechtsmängeln sowie solchen
            Mängeln, die seine Funktionsfähigkeit oder Gebrauchstauglichkeit
            mehr als nur unerheblich beeinträchtigen.
          </p>
          <p>
            12.4. Soweit OMTO gemäß Ziffer 12.3. bei leicht fahrlässiger
            Verletzung von Kardinalpflichten dem Grunde nach auf Schadensersatz
            haftet, ist diese Ersatzpflicht beschränkt auf Schäden, die OMTO bei
            Vertragsschluss als mögliche Folge einer Vertragsverletzung
            vorausgesehen hat oder bei Anwendung verkehrsüblicher Sorgfalt hätte
            voraussehen müssen; mittelbare Schäden und Folgeschäden, die Folge
            von Mängeln des Vertragsgegenstands sind, sind außerdem nur
            ersatzfähig, soweit solche Schäden bei bestimmungsgemäßer Verwendung
            des Vertragsgegenstands typischerweise zu erwarten sind.
          </p>
          <p>
            12.5. Die vorstehenden Haftungsausschlüsse und -beschränkungen gemäß
            Ziffern 12.3. und 12.4. gelten in gleichem Umfang zugunsten der
            Organe, gesetzlichen Vertreter, Mitarbeiter und sonstigen
            Erfüllungsgehilfen von OMTO.
          </p>
          <p>
            12.6. Eine Änderung der Beweislast zum Nachteil des Kunden ist mit
            den Regelungen in dieser Ziffer 12 ausdrücklich nicht verbunden.
          </p>
        </div>
      </div>

      <div
        id="vertraulichkeit"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            13. Vertraulichkeit
          </h2>
          <p>
            13.1. Die Parteien vereinbaren, über vertrauliche Informationen
            Stillschweigen zu wahren. Diese Verpflichtung besteht für einen
            Zeitraum von zwei Jahren nach Beendigung aller Verträge, für die
            diese AGB gelten, fort. Weitergehende Vertraulichkeitspflichten aus
            dem Datenschutzrecht bleiben unberührt.
          </p>
          <p>
            13.2. „Vertrauliche Informationen“ sind alle Informationen und
            Unterlagen der jeweils anderen Partei, die als vertraulich
            gekennzeichnet oder aus den Umständen heraus als vertraulich
            anzusehen sind, insbesondere Informationen über betriebliche
            Abläufe, Geschäftsbeziehungen und Know-how.
          </p>
          <p>
            13.3. Von dieser Verpflichtung ausgenommen sind solche vertraulichen
            Informationen
          </p>
          <ul className="list-alpha pl-7 space-y-1">
            <li>
              die dem Empfänger bei Abschluss des Vertrags nachweislich bereits
              bekannt waren oder danach von dritter Seite bekannt werden, ohne
              dass dadurch eine Vertraulichkeitsvereinbarung, gesetzliche
              Vorschriften oder behördliche Anordnungen verletzt werden
            </li>
            <li>
              die bei Abschluss des Vertrags öffentlich bekannt sind oder danach
              öffentlich bekannt gemacht werden, soweit dies nicht auf einer
              Verletzung der Vertraulichkeitsvereinbarung beruht
            </li>
            <li>
              die aufgrund gesetzlicher Verpflichtungen oder auf Anordnung eines
              Gerichts oder einer Behörde offengelegt werden müssen. Soweit
              zulässig und möglich wird der zur Offenlegung verpflichtete
              Empfänger die andere Partei vorab unterrichten und ihr Gelegenheit
              geben, gegen die Offenlegung vorzugehen
            </li>
          </ul>
          <p>
            13.4. Die Parteien werden nur solchen externen Dienstleistern bzw.
            Beratern Zugang zu vertraulichen Informationen gewähren, die dem
            Berufsgeheimnis unterliegen oder denen zuvor den
            Geheimhaltungsverpflichtungen dieses Vertrags entsprechende
            Verpflichtungen auferlegt worden sind. Des Weiteren werden die
            Parteien nur denjenigen Mitarbeitern die vertraulichen Informationen
            offenlegen, die diese für die Durchführung dieses Vertrags kennen
            müssen, und diese Mitarbeiter auch für die Zeit nach ihrem
            Ausscheiden in arbeitsrechtlich zulässigem Umfang zur Geheimhaltung
            verpflichten.
          </p>
        </div>
      </div>

      <div
        id="abtretung"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            14. Abtretung, Aufrechnung
          </h2>
          <p>
            14.1. Der Kunde darf Rechte und Pflichten aus oder im Zusammenhang
            mit dem Vertrag nur nach schriftlicher Zustimmung von OMTO auf
            Dritte übertragen.
          </p>
          <p>
            14.2. Gegen Entgeltforderungen von OMTO kann der Kunde nur mit
            unbestrittenen oder rechtskräftig festgestellten Forderungen
            aufrechnen. Dem Kunden steht die Geltendmachung eines
            Zurückbehaltungsrechtes nur wegen Gegenansprüchen aus demselben
            Vertragsverhältnis zu.
          </p>
        </div>
      </div>

      <div
        id="schlussbestimmungen"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            15. Schlussbestimmungen
          </h2>
          <p>
            15.1. Das Vertragsverhältnis zwischen OMTO und dem Kunden unterliegt
            ausschließlich dem Recht der Bundesrepublik Deutschland unter
            Ausschluss des UN-Kaufrechts.
          </p>
          <p>
            15.2. Ist der Kunde Kaufmann im Sinne des Handelsgesetzbuchs,
            juristische Person des öffentlichen Rechts oder ein
            öffentlich-rechtliches Sondervermögen, ist ausschließlicher – auch
            internationaler – Gerichtsstand für alle sich aus dem
            Vertragsverhältnis unmittelbar oder mittelbar ergebenden
            Streitigkeiten 12103 Berlin. OMTO ist jedoch in allen Fällen auch
            berechtigt, Klage am Erfüllungsort der Vertragsverpflichtung oder am
            allgemeinen Gerichtsstand des Kunden zu erheben. Vorrangige
            gesetzliche Vorschriften, insbesondere zu ausschließlichen
            Zuständigkeiten, bleiben unberührt.
          </p>
          <p>
            15.3. Soweit der Vertrag oder diese AGB Regelungslücken enthalten,
            gelten zur Ausfüllung dieser Lücken diejenigen rechtlich wirksamen
            Regelungen als vereinbart, welche die Vertragspartner nach den
            wirtschaftlichen Zielsetzungen des Vertrages und dem Zweck dieser
            AGB vereinbart hätten, wenn sie die Regelungslücke gekannt hätten.
          </p>
        </div>
      </div>

      <div id="sla" className="flex flex-col items-start lg:flex-row gap-8">
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-[20px] leading-[160%] text-[#031F47]">
            16. Einbeziehung der Service-Level-Vereinbarung (Anhang SLA)
          </h2>
          <p>
            16.1. Die Service-Level-Vereinbarung gemäß Anhang SLA ist
            ausdrücklich Teil dieser AGBDKTB und wird als solche mit den
            AGB-DKTB in den Vertrag einbezogen.
          </p>
          <p>
            16.2. Bei Auslegungsproblemen oder Widersprüchen zwischen den
            Bestimmungen dieser AGB-DKTB und den Bestimmungen im Anhang SLA
            gelten vorrangig die Bestimmungen des Anhangs SLA.
          </p>
        </div>
      </div>

      <div
        id="erklaerung"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-center text-[20px] leading-[160%] text-[#031F47]">
            Erklärung des Kunden / der für den Kunden handelnden Person:
          </h2>
          <p>
            Ich habe die AGB-DKTB zur Kenntnis genommen und bin mit der
            Einbeziehung dieser AGBDKBT einschließlich des Anhangs SLA in das
            Vertragsverhältnis mit der OMTO GmbH über die Bereitstellung,
            Nutzungsgewährung, Hardwareüberlassung sowie die sonstigen
            Leistungen von OMTO in Bezug auf den Dienst „OMTO – Digitale
            KrankentransportBestellung“ (OMTO-DKTB-Dienst) einverstanden:
          </p>

          <div className="mt-8 space-y-8 flex flex-col items-center">
            <div className="w-[350px]">
              <div className="border-b border-gray-300 h-8" />
              <p className="text-xs text-center">Ort, Datum</p>
            </div>
            <div className="w-[350px]">
              <div className="border-b border-gray-300 h-8" />
              <p className="text-xs text-center">Name des Kunden / Firma</p>
            </div>
            <div className="w-[350px]">
              <div className="border-b border-gray-300 h-8" />
              <p className="text-xs text-center">Signatur für den Kunden</p>
            </div>
            <div className="w-[350px]">
              <div className="border-b border-gray-300 h-8" />
              <p className="text-xs text-center">
                Vor- und Nachname signierende Person
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        id="sla-anhang"
        className="flex flex-col items-start lg:flex-row gap-8"
      >
        <div className="w-full flex flex-col gap-6">
          <h2 className="font-bold text-center text-[20px] leading-[160%] text-[#031F47]">
            Anhang SLA
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="font-semibold text-[16px] leading-[160%] text-[#031F47] mb-3">
                1. Service-Level
              </h3>
              <ul className="list-none pl-0 space-y-2">
                <li className="flex">
                  <span className="mr-2">1.1.</span>
                  <span>
                    Für die Verfügbarkeit bzw. die Beseitigung von Störungen des
                    OMTO-DKTB-Dienstes gelten die nachfolgenden
                    Service-Level-Bestimmungen (SLA).
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">1.2.</span>
                  <span>
                    Eine Verfügbarkeit ist gegeben, wenn der OMTO-DKTB-Dienst
                    ohne wesentliche Funktionsbeeinträchtigungen zum
                    vertragsgemäßen Gebrauch verwendet werden kann.
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-[16px] leading-[160%] text-[#031F47] mb-3">
                2. Mindestverfügbarkeit
              </h3>
              <ul className="list-none pl-0 space-y-4">
                <li className="flex">
                  <span className="mr-2">2.1.</span>
                  <span>
                    OMTO gewährleistet eine Mindestverfügbarkeit des
                    OMTO-DKTB-Dienstes (im Folgenden kurz „Verfügbarkeit“) von
                    98% im Mittel bezogen auf ein Kalenderquartal. Die
                    gewährleistete Verfügbarkeit im Kalenderquartalsmittel
                    berechnet sich nach der Formel:
                    {/* Desktop formula */}
                    <div className="hidden md:block text-center my-4">
                      <div className="flex items-center justify-center gap-2">
                        <div className="text-lg font-medium">
                          Verfügbarkeit =
                        </div>
                        <div className="flex items-center justify-center gap-2">
                          <div className="text-left">
                            <div className="border-b text-xs border-gray-400 px-4">
                              Regelbetriebszeit - externe Störung - interne
                              Störung
                            </div>
                            <div className="px-4 text-xs">
                              Regelbetriebszeit - externe Störung
                            </div>
                          </div>
                          <span className="text-lg">× 100</span>
                        </div>
                      </div>
                    </div>
                    {/* Mobile formula */}
                    <div className="md:hidden text-center my-4">
                      <div className="space-y-2">
                        <div className="text-lg font-medium">
                          Verfügbarkeit =
                        </div>
                        <div className="flex flex-col items-center">
                          <div className="border-b border-gray-400 px-3 text-sm mt-1">
                            Regelbetriebszeit - externe Störung - interne
                            Störung
                          </div>
                          <div className="text-sm px-3 mt-1">
                            Regelbetriebszeit - externe Störung
                          </div>
                        </div>
                        <div className="text-lg font-medium">× 100</div>
                      </div>
                    </div>
                    <div className="mb-2">
                      Die Parameter der Formel werden wie folgt definiert:
                    </div>
                    <ul className="list-alpha pl-6 space-y-2">
                      <li>
                        <div className="italic mb-4">Regelbetriebszeit:</div>
                        Die Regelbetriebszeit des OMTO-DKTB-Dienstes beträgt 24
                        Stunden täglich an sieben Tagen in der Woche.
                      </li>
                      <li>
                        <div className="italic mb-4">externe Störung:</div>
                        OMTO übernimmt keine Gewähr für
                        Nichtverfügbarkeitszeiten, die auf externen Einflüssen
                        beruhen, welche OMTO nicht zu vertreten hat. Externe
                        Störungen sind demgemäß Zeiträume, in denen eine
                        Nichtverfügbarkeit insbesondere aus den folgenden
                        Gründen besteht:
                        <ul className="list-disc pl-6 space-y-1 mt-2">
                          <li>
                            höhere Gewalt; als Fälle höherer Gewalt sollen
                            insbesondere gelten: Epidemien, Pandemien, Erdbeben,
                            Überflutungen, Revolution, Anschläge, Krieg,
                            regionaler oder landesweiter Ausfall des Internet,
                            ein Ausfall von mehr als 30% der Mitarbeiter des
                            Rechenzentrums oder von OMTO aufgrund eines
                            mindestens bundeslandweiten Ereignisses;
                          </li>
                          <li>
                            Beeinträchtigungen, die auf Ausfällen und/oder
                            Fehlfunktionen von Datennetzen, technischen Anlagen
                            und/oder Netzkomponenten im Verantwortungsbereich
                            des Kunden und/oder außerhalb des
                            Verantwortungsbereichs von OMTO beruhen; der
                            Verantwortungsbereich von OMTO für Datennetze,
                            technische Anlagen und Netzkomponenten endet an den
                            Datenschnittstellen des von OMTO genutzten
                            Rechenzentrums zu den öffentlichen Datennetzen;
                          </li>
                          <li>
                            Ausfälle und/oder Fehlfunktionen, die durch
                            eingehende IT-Angriffe auf die Rechner bzw. Systeme
                            des Kunden verursacht wurden;
                          </li>
                          <li>
                            Ausfälle und/oder Fehlfunktionen, die durch Hacking
                            von Systemen außerhalb des Verantwortungsbereichs
                            von OMTO verursacht wurden, oder die durch
                            eingehende IT-Angriffe auf die Rechner bzw. Systeme
                            von OMTO verursacht wurden, wenn die von OMTO
                            verwendeten ITSicherheitsmaßnahmen zum Zeitpunkt des
                            Angriffs dem Stand der Technik entsprochen haben;
                          </li>
                          <li>
                            Ausfälle und/oder Fehlfunktionen, die durch
                            unsachgemäße Benutzung und/oder Beschädigung von
                            Soft- oder Hardware seitens des Kunden oder seitens
                            Dritter entstanden sind;
                          </li>
                          <li>
                            Verzug des Kunden mit einer notwendigen
                            Mitwirkungshandlung;
                          </li>
                          <li>
                            Unterbrechungszeiten in der Leistungsbereitstellung
                            von OMTO, die auf Vertragsbestimmungen, insbesondere
                            auf ein Zurückbehaltungsrecht und/oder einen
                            Leistungsausschluss wegen Zahlungsverzugs oder
                            anderer Pflichtverletzungen des Kunden
                            zurückzuführen sind.
                          </li>
                        </ul>
                      </li>
                      <li>
                        <div className="italic mb-4">interne Störung:</div>
                        Interne Störungen sind Zeiten, in denen eine
                        Nichtverfügbarkeit besteht, welche nicht auf einer
                        externen Störung beruht.
                      </li>
                    </ul>
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">2.2.</span>
                  <span>
                    <div className="mb-4">
                      Nichtverfügbarkeitszeiten (interne oder externe Störung)
                      werden wie folgt gemessen:
                    </div>
                    <ul className="list-alpha pl-6 space-y-1">
                      <li>
                        Die Nichtverfügbarkeitszeit läuft 240 Minuten nach
                        Eingang der Fehlermeldung des Kunden gemäß Ziffer 2.4.
                        bei OMTO an, sofern die Störung dann noch besteht bzw.
                        durch den Support von OMTO nicht innerhalb der
                        Bearbeitungszeit von 240 Minuten beseitigt werden
                        konnte.
                      </li>
                      <li>
                        Die Nichtverfügbarkeitszeit endet, sobald die
                        Verfügbarkeit im Sinne der Ziffer 1.2. wiederhergestellt
                        ist.
                      </li>
                      <li>
                        Für die Berechnung einer Einhaltung der gewährleisteten
                        Mindestverfügbarkeit im Mittel des Kalenderquartals
                        gemäß Ziffer 2.1. sind (gemäß der aufgeführten Formel)
                        nur die auf einer internen Störung beruhenden
                        Nichtverfügbarkeitszeiten zu berücksichtigen bzw.
                        abzuziehen.
                      </li>
                    </ul>
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">2.3.</span>
                  <span>
                    Nach Ablauf eines jeden Kalenderquartals wird die Berechnung
                    der Verfügbarkeitszeit „genullt“, d.h. zu Beginn eines jeden
                    Kalenderquartals beginnt die Berechnung der Verfügbarkeit
                    für das laufende Kalenderquartal erneut. Der Zeitraum vom
                    Bereitstellungsbeginn bis zum Ende des ersten
                    Kalenderquartals gilt als Rumpfquartal, ebenso der Beginn
                    des letzten Kalenderquartals der Vertragslaufzeit bis zur
                    Beendigung des Vertrages. Die Zeiten eines Rumpfquartals
                    werden auf ein Kalenderquartal hochgerechnet.
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">2.4.</span>
                  <span>
                    <div className="mb-4">
                      Ein Fehler ist vom Kunden unverzüglich an OMTO über die
                      Kommunikationsverbindungen des technischen Supports zu
                      melden. Die Fehlermeldung des Kunden soll soweit möglich
                      folgende Informationen beinhalten:
                    </div>
                    <ul className="list-alpha pl-6 space-y-1">
                      <li>Tag und Uhrzeit der Fehlerfeststellung;</li>
                      <li>an welcher Komponente trat der Fehler auf;</li>
                      <li>
                        die Bedienungsschritte, im Zuge derer der Fehler
                        aufgetreten ist bzw. die den Fehler verursacht haben;
                      </li>
                      <li>
                        die (unfachmännische) Beschreibung des Fehlers und
                        seiner Auswirkungen auf die Funktion des
                        OMTO-DKTB-Dienstes;
                      </li>
                      <li>Angabe zur Reproduzierbarkeit (Ja/Nein).</li>
                    </ul>
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-[16px] leading-[160%] text-[#031F47] mb-3">
                3. Reaktionszeit
              </h3>
              <ul className="list-none pl-0 space-y-2">
                <li className="flex">
                  <span className="mr-2">3.1.</span>
                  <span>
                    <div className="mb-4">
                      Die Reaktionszeit von OMTO nach Fehlermeldung des Kunden
                      (Ziffer 2.4.) wird auf Basis der jeweiligen
                      Klassifizierung nach Fehlersymptomen wie folgt gestaffelt:
                    </div>
                    {/* Table for desktop */}
                    <div className="hidden lg:block overflow-x-auto">
                      <table className="w-full border-collapse border border-gray-300 text-sm">
                        <thead>
                          <tr className="bg-white">
                            <th className="border border-gray-300 px-3 py-2 text-left font-semibold">
                              Priorität
                            </th>
                            <th className="border border-gray-300 px-3 py-2 text-left font-semibold">
                              Klassifizierung
                            </th>
                            <th className="border border-gray-300 px-3 py-2 text-left font-semibold">
                              Beschreibung
                            </th>
                            <th className="border border-gray-300 px-3 py-2 text-left font-semibold">
                              Reaktionszeit (R)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td className="border border-gray-300 px-3 py-2 font-semibold">
                              I.
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              dringend; der Betriebsablauf ist unterbrochen
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              die Anwendung ist nicht lauffähig, es kommt zu
                              Programmabstürzen
                              <br />
                              das Auswählen und/oder die Übergabe von Daten kann
                              nicht gestartet werden
                              <br />
                              Daten werden nicht oder nicht richtig und
                              vollständig gespeichert oder gelesen
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              R = vier (4) Stunden
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-3 py-2 font-semibold">
                              II.
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              hoch; der Betriebsablauf ist beeinträchtigt
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              Die Funktionsweise der Anwendung ist
                              beeinträchtigt oder es kommt zu Fehlfunktionen,
                              insbesondere:
                              <br />
                              Meldungen sind unverständlich oder stehen nicht im
                              richtigen Kontext zur aufgerufenen Funktion
                              <br />
                              Funktionalitäten zeigen nicht die zu erwartenden
                              Ergebnisse
                              <br />
                              Das Antwortzeitverhalten verhindert eine übliche
                              Nutzung des Dienstes
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              R = ein (1) Werktag
                            </td>
                          </tr>
                          <tr>
                            <td className="border border-gray-300 px-3 py-2 font-semibold">
                              III.
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              niedrig; der Betriebsablauf ist nicht
                              beeinträchtigt
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              Ein Arbeiten mit dem Dienst ist möglich, wenn auch
                              nicht durchgängig innerhalb der vereinbarten
                              Parameter
                              <br />
                              Bedienerfreundlichkeit ist verbesserungsbedürftig
                              <br />
                              Fehlfunktionen können umgangen werden
                            </td>
                            <td className="border border-gray-300 px-3 py-2">
                              R = drei (3) Werktage
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    {/* Cards for mobile */}
                    <div className="lg:hidden space-y-4">
                      <div className="border border-gray-300 rounded p-4">
                        <div className="font-semibold mb-2">Priorität I</div>
                        <div className="mb-2">
                          <strong>Klassifizierung:</strong> der Betriebsablauf
                          ist unterbrochen
                        </div>
                        <div className="mb-2">
                          <strong>Beschreibung:</strong>
                          <ul className="list-disc list-inside ml-2 mt-1">
                            <li>
                              die Anwendung ist nicht lauffähig, es kommt zu
                              Programmabstürzen
                            </li>
                            <li>
                              das Auswählen und/oder die Übergabe von Daten kann
                              nicht gestartet werden
                            </li>
                            <li>
                              Daten werden nicht oder nicht richtig und
                              vollständig gespeichert oder gelesen
                            </li>
                          </ul>
                        </div>
                        <div>
                          <strong>Reaktionszeit:</strong> R = vier (4) Stunden
                        </div>
                      </div>

                      <div className="border border-gray-300 rounded p-4">
                        <div className="font-semibold mb-2">Priorität II</div>
                        <div className="mb-2">
                          <strong>Klassifizierung:</strong> hoch; der
                          Betriebsablauf ist beeinträchtigt
                        </div>
                        <div className="mb-2">
                          <strong>Beschreibung:</strong> Die Funktionsweise der
                          Anwendung ist beeinträchtigt oder es kommt zu
                          Fehlfunktionen, insbesondere:
                          <ul className="list-disc list-inside ml-2 mt-1">
                            <li>
                              Meldungen sind unverständlich oder stehen nicht im
                              richtigen Kontext zur aufgerufenen Funktion
                            </li>
                            <li>
                              Funktionalitäten zeigen nicht die zu erwartenden
                              Ergebnisse
                            </li>
                            <li>
                              Das Antwortzeitverhalten verhindert eine übliche
                              Nutzung des Dienstes
                            </li>
                          </ul>
                        </div>
                        <div>
                          <strong>Reaktionszeit:</strong> R = ein (1) Werktag
                        </div>
                      </div>

                      <div className="border border-gray-300 rounded p-4">
                        <div className="font-semibold mb-2">Priorität III</div>
                        <div className="mb-2">
                          <strong>Klassifizierung:</strong> niedrig; der
                          Betriebsablauf ist nicht beeinträchtigt
                        </div>
                        <div className="mb-2">
                          <strong>Beschreibung:</strong>
                          <ul className="list-disc list-inside ml-2 mt-1">
                            <li>
                              Ein Arbeiten mit dem Dienst ist möglich, wenn auch
                              nicht durchgängig innerhalb der vereinbarten
                              Parameter
                            </li>
                            <li>
                              Bedienerfreundlichkeit ist verbesserungsbedürftig
                            </li>
                            <li>Fehlfunktionen können umgangen werden</li>
                          </ul>
                        </div>
                        <div>
                          <strong>Reaktionszeit:</strong> R = drei (3) Werktage
                        </div>
                      </div>
                    </div>
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">3.2.</span>
                  <span>
                    Die Reaktionszeit ist gewahrt, wenn OMTO innerhalb des
                    Laufes der Reaktionszeit angemessene Maßnahmen zur
                    Fehlerbehebung einleitet.
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">3.3.</span>
                  <span>
                    OMTO wird dem Kunden auf dessen Wunsch nach Meldung eines
                    Fehlers eine unverbindliche Einschätzung zu der für die
                    Fehlerbeseitigung voraussichtlich benötigte Zeit geben.
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-[16px] leading-[160%] text-[#031F47] mb-3">
                4. Nicht geschuldete Leistungen
              </h3>
              <ul className="list-none pl-0 space-y-2">
                <li className="flex">
                  <span className="mr-2">4.1.</span>
                  <span>
                    <div className="mb-4">
                      OMTO ist – vorbehaltlich abweichender Vereinbarungen im
                      Einzelfall – ausdrücklich nicht verpflichtet, folgende
                      Leistungen auszuführen:
                    </div>
                    <ul className="list-alpha pl-6 space-y-1">
                      <li>
                        Anpassung der Dienstsoftware an eine geänderte Hardware-
                        oder Softwareumgebung einschließlich der Anpassung an
                        veränderte Betriebssysteme;
                      </li>
                      <li>
                        eine über die geschuldete Fehlerbeseitigung
                        hinausgehende Beratung.
                      </li>
                    </ul>
                  </span>
                </li>
                <li className="flex">
                  <span className="mr-2">4.2.</span>
                  <span>
                    Die Aufzählung in vorstehender Ziffer 4.1. ist nicht
                    abschließend. Aus der fehlenden Nennung von Leistungen kann
                    nicht geschlossen werden, dass diese Leistungen Gegenstand
                    der vertraglichen Pflichten von OMTO sind. Die Rechte des
                    Kunden aufgrund der von OMTO geschuldeten Haftung für
                    Leistungsstörungen bleiben unberührt.
                  </span>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="font-semibold text-[16px] leading-[160%] text-[#031F47] mb-3">
                5. Mitwirkungspflichten des Kunden
              </h3>
              <p>
                Der Kunde wird OMTO in jeder Hinsicht bei der Erfüllung der
                obliegenden Leistungen unterstützen, beispielsweise durch die
                Übermittlung von Testfällen und/oder Testdaten, das
                Bereitstellen von Fehlerprotokollen, Screen-Shots etc.
              </p>
            </div>
          </div>
        </div>
      </div>
    </DocumentLayout>
  );
};

export default Terms;
